<template>
  <BaseDialog
    ref="baseDialog"
    modal-id="deleteGuardianDialog"
    :title="$t('guardians.deleteGuardian')"
    :confirm-text="$t('guardians.delete')"
    confirm-variant="danger"
    @confirm="handleConfirm"
  >
    <template #body>
      <p>
        {{$t('guardians.confirmDelete')}} <strong>{{ guardianName }}</strong>?
      </p>
      <p class="text-danger">{{$t('guardians.irreversibleAction')}}</p>
    </template>
  </BaseDialog>
</template>

<script setup>
import { ref, defineEmits, defineExpose } from 'vue';
import BaseDialog from '@/components/common/BaseDialog.vue';

const baseDialog = ref(null);
const guardianName = ref('');
const guardianId = ref(null);

const emit = defineEmits(['delete']);

const open = (guardian) => {
  guardianName.value = guardian.username;
  guardianId.value = guardian.id;
  baseDialog.value?.openDialog();
};

const handleConfirm = () => {
  emit('delete', guardianId.value);
  baseDialog.value?.closeDialog();
};

defineExpose({ open });
</script>
